// before 20-5-2026

// import React, { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/esm/Container';
// import { Notify } from '../Utility/Notify';
// import { GetOneDevelopersData, UpdateoneDevelopersData } from '../Redux/Actions/DevelopersAction';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useParams } from 'react-router-dom';
// import Row from 'react-bootstrap/esm/Row';
// import EditIcon from '@mui/icons-material/Edit';
// import { Col } from 'react-bootstrap';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { useTheme } from '@mui/material/styles';
// import { CircularProgress } from '@mui/material';

// export const UpdateOneDeveloperData = () => {
//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const theme = useTheme();
//   const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

//   const { id } = useParams();
//   const dispatch = useDispatch();
//   const [Developernameupdate, setDevelopernameupdate] = useState('');
//   const [loadingupdate, setloadingupdate] = useState(true);
//   const [updateDeveloperLoading, setUpdateDeveloperLoading] = useState(false);

//   //get data for one developer

//   useEffect(() => {
//     const run = async () => {
//       await dispatch(GetOneDevelopersData(id));
//     };
//     run();
//   }, []);

//   const resdataforonedeveloper = useSelector((state) => state.AllDevelopers.Developers);

//   let onedeveloperdata = [];
//   if (resdataforonedeveloper && resdataforonedeveloper.data) {
//     onedeveloperdata = resdataforonedeveloper.data;
//   } else {
//     onedeveloperdata = [];
//   }

//   // let onedeveloperdata = Array.isArray(resdataforonedeveloper?.data) ? resdataforonedeveloper.data : [];

//   useEffect(() => {
//     setDevelopernameupdate(onedeveloperdata.name);
//   }, [onedeveloperdata]);

//   const onnameforupdate = (e) => {
//     setDevelopernameupdate(e.target.value);
//   };

//   //update action
//   const updateaction = async (e) => {
//     e.preventDefault();
//     if (Developernameupdate === '') {
//       Notify('error', 'Please fill the developer name', 'error');
//       return;
//     } else {
//       setloadingupdate(true);
//       setUpdateDeveloperLoading(true);

//       await dispatch(UpdateoneDevelopersData(id, { name: Developernameupdate }));
//       setloadingupdate(false);
//       setUpdateDeveloperLoading(false);
//     }
//   };

//   const resUpdate = useSelector((state) => state.AllDevelopers.Developers);

//   useEffect(() => {
//     if (loadingupdate === false) {
//       if (resUpdate && resUpdate.data) {
//         Notify('success', 'Developer Updated Successfully', 'success');
//         setloadingupdate(true);
//         window.location.href = '#/Developers';
//       }
//     }
//   }, [loadingupdate]);

//   return (
//     <Container className="startpage">
//       <Row>
//         <Col sm={2}></Col>
//         <Col sm={10}>
//           {/* <div className=' d-flex justify-content-between w-100'>
//             <div className='d-flex '>
//             <div className='mx-4 '>Update  Developer Data</div>
//             <a style={{textDecoration:'none'}} href='/Developers' className='goback'>{"<<"} Go Back </a>
//             </div>
             
           
//         </div> */}

//           <Link
//             to={
//               userlogin?.data?.role === 'Admin'
//                 ? '/AllLeadsForAdmin'
//                 : userlogin?.data?.role === 'Marketer'
//                   ? '/ALLLeadsForMarketer'
//                   : userlogin?.data?.role === 'Accountant'
//                     ? '/LeadsForAccountant'
//                     : '/Dashboard'
//             }
//             style={{ textDecoration: 'none', color: '#102dff' }}
//           >
//             <span style={{ fontWeight: 'bold' }}>Home</span>
//           </Link>

//           <KeyboardDoubleArrowRightIcon />

//           <Link to={`/Developers`} style={{ textDecoration: 'none', color: '#0F7687' }}>
//             <span style={{ fontWeight: 'bold', color: '#666' }}>Home Developers</span>
//           </Link>

//           <KeyboardDoubleArrowRightIcon />

//           <span style={{ color: '#666' }}>Update Developer</span>

//           <div className="d-flex flex-wrap justify-content-center">
//             <Row
//               style={{
//                 width: '100%',
//                 marginTop: '20px',
//                 color: mode === 'dark' ? 'white' : '#0F7687',
//                 backgroundColor: mode === 'dark' ? '#333' : '#f5f5f5',
//                 borderRadius: '10px',
//               }}
//             >
//               <Container
//                 style={{
//                   background: mode === 'dark' ? '#333' : '#fff',
//                   padding: '25px',
//                   borderRadius: '15px',
//                   marginTop: '20px',
//                 }}
//               >
//                 <label for="name">Developer Name*</label>
//                 <input
//                   onChange={onnameforupdate}
//                   value={Developernameupdate}
//                   className="inputsaddclient"
//                   type="text"
//                   id="name"
//                   name="firstname"
//                   placeholder="Developer name.."
//                 />
//               </Container>
//             </Row>

//             <hr />
//             {/* <Row className='d-flex justify-content-center' style={{width:'100%',marginTop:'20px',textAlign:'center'}}>
//     <div onClick={updateaction}  style={{background:'#0F7687'}} className='addnewclient'  type="submit" ><EditIcon/> Update Developer</div>

//     </Row> */}

//             <Row
//               className="d-flex justify-content-center"
//               style={{ width: '100%', marginTop: '15px', textAlign: 'center' }}
//             >
//               <div
//                 onClick={!updateDeveloperLoading ? updateaction : null}
//                 className="addnewclient"
//                 style={{
//                   background: '#102dff',
//                   pointerEvents: updateDeveloperLoading ? 'none' : 'auto',
//                   opacity: updateDeveloperLoading ? 0.6 : 1,
//                   cursor: updateDeveloperLoading ? 'not-allowed' : 'pointer',
//                   display: 'flex',
//                   justifyContent: 'center',
//                   alignItems: 'center',
//                   gap: '6px',
//                   height: '40px',
//                 }}
//                 type="submit"
//               >
//                 {updateDeveloperLoading ? (
//                   <CircularProgress size={20} style={{ color: 'white' }} />
//                 ) : (
//                   <>
//                     <EditIcon /> Update Developer
//                   </>
//                 )}
//               </div>
//             </Row>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };






















// 20-5-2026
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import { GetOneDevelopersData, UpdateoneDevelopersData } from '../Redux/Actions/DevelopersAction';
import { Notify } from '../Utility/Notify';
import EditIcon from '@mui/icons-material/Edit';
import { useSidebarWidth } from '../Utility/useSidebarWidth';

export const UpdateOneDeveloperData = () => {
  const theme    = useTheme();
  const isDark   = theme.palette.mode === 'dark';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id }   = useParams();

  /* ✅ sidebar sync */
  const sidebarWidth = useSidebarWidth();

  const [name,    setName]    = useState('');
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  /* ── fetch existing developer data ── */
  useEffect(() => {
    const run = async () => {
      await dispatch(GetOneDevelopersData(id));
    };
    run();
  }, []);

  const resdataforonedeveloper = useSelector((state) => state.AllDevelopers.Developers);
  const oneDeveloper = resdataforonedeveloper?.data || null;

  useEffect(() => {
    if (oneDeveloper?.name) {
      setName(oneDeveloper.name);
    }
  }, [oneDeveloper]);

  /* ── submit update ── */
  const onsubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return Notify('error', 'Please fill the developer name', 'error');
    setLoading(true);
    setSending(true);
    await dispatch(UpdateoneDevelopersData(id, { name: name.trim() }));
    setLoading(false);
    setSending(false);
  };

  const resUpdate = useSelector((state) => state.AllDevelopers.Developers);
  useEffect(() => {
    if (loading === false) {
      if (resUpdate?.data) {
        Notify('success', 'Developer Updated Successfully', 'success');
        setTimeout(() => navigate('/Developers'), 1200);
      } else {
        Notify('error', 'Failed to update Developer', 'error');
      }
      setLoading(true);
    }
  }, [loading]);

  /* ─── shared styles ─── */
  const inputStyle = {
    width: '100%', padding: '13px 16px', borderRadius: '10px',
    border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px', outline: 'none', transition: 'all 0.2s',
    fontFamily: "'DM Sans',sans-serif", boxSizing: 'border-box',
  };
  const labelStyle = {
    display: 'block', fontSize: '11px', fontWeight: 700,
    letterSpacing: '0.08em', textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b', marginBottom: '8px',
  };
  const onFocus = (e) => {
    e.target.style.borderColor     = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow       = '0 0 0 3px rgba(37,99,235,0.12)';
  };
  const onBlur = (e) => {
    e.target.style.borderColor     = isDark ? '#2d3248' : '#e2e8f0';
    e.target.style.backgroundColor = isDark ? '#151827' : '#f8fafc';
    e.target.style.boxShadow       = 'none';
  };

  return (
    <div style={{
      position: 'fixed',
      top: '50px', left: sidebarWidth, right: 0, bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px',
      }}>
        <Link to="/Developers" style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}>
          Developers
        </Link>
        <span style={{ color: isDark ? '#4b5563' : '#d1d5db' }}>/</span>
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>Update Developer</span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%', maxWidth: '720px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px', padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{ fontSize: '22px', fontWeight: 700, color: isDark ? '#f1f5f9' : '#0d1b3e', margin: '0 0 4px', letterSpacing: '-0.4px' }}>
              Update Developer
            </h1>
            <p style={{ fontSize: '13px', color: isDark ? '#6b7280' : '#94a3b8', margin: 0 }}>
              Edit the developer name in the CRM database
            </p>
          </div>

          {/* field */}
          <div style={{ marginBottom: '8px' }}>
            <label style={labelStyle}>Developer Name *</label>
            <input
              style={inputStyle}
              value={name}
              onChange={e => setName(e.target.value)}
              type="text"
              placeholder="e.g. Emaar, Damac"
              onFocus={onFocus}
              onBlur={onBlur}
              onKeyDown={e => { if (e.key === 'Enter') onsubmit(e); }}
              autoFocus
            />
          </div>

          {/* hint */}
          <p style={{ fontSize: '12px', color: isDark ? '#4b5563' : '#94a3b8', margin: '8px 0 0' }}>
            Enter the full developer name as it will appear across the system
          </p>

          {/* divider */}
          <div style={{ height: '1px', backgroundColor: isDark ? '#2a2f45' : '#e8eaf0', margin: '28px 0' }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={!sending ? onsubmit : null}
              disabled={sending}
              type="button"
              style={{
                flex: 1, padding: '14px 24px', borderRadius: '10px', border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff', fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: sending ? 'not-allowed' : 'pointer',
                opacity: sending ? 0.7 : 1,
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => { if (!sending) { e.currentTarget.style.transform = 'translateY(-1px)'; e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)'; } }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)'; }}
            >
              {sending
                ? <><CircularProgress size={16} style={{ color: '#fff' }} /><span>Updating…</span></>
                : <><EditIcon sx={{ fontSize: 17 }} /><span>Update Developer</span></>}
            </button>

            <button
              type="button"
              onClick={() => navigate('/Developers')}
              style={{
                padding: '14px 28px', borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px', fontWeight: 700,
                letterSpacing: '0.08em', textTransform: 'uppercase',
                cursor: 'pointer', transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8'; e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0'; e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b'; }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};